import type {RumInitConfiguration} from '@datadog/browser-rum';
import type {NodeEnvironment} from '#types/environment.js';
import {getCurrentEnv} from '#utils/environment.js';
import {datadogRum} from '@datadog/browser-rum';

const RUM_SERVICE = 'vortex-frontend';
const RUM_APP_ID = '7574dd34-c9a9-490d-b41b-07ce1834629a';
const RUM_CLIENT_TOKEN = 'pubb657b0315bba69e1c469dd94c3049186';
const CURRENT_ENV = getCurrentEnv();

export const ENV_SPECIFIC_CONFIGS: Record<
  NodeEnvironment,
  Partial<RumInitConfiguration>
> = {
  development: {
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: false,
  },

  production: {
    sessionSampleRate: 50,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
  },
};

const DEFAULT_CONFIG: RumInitConfiguration = {
  site: 'datadoghq.com',
  applicationId: RUM_APP_ID,
  clientToken: RUM_CLIENT_TOKEN,
  service: RUM_SERVICE,
  env: CURRENT_ENV,
  defaultPrivacyLevel: 'mask-user-input',
  ...ENV_SPECIFIC_CONFIGS[CURRENT_ENV],
};

export const initDataDog = (config: Partial<RumInitConfiguration> = {}) => {
  datadogRum.init({...DEFAULT_CONFIG, ...config});
};
